import { ref } from 'vue';

class EventBus {
    constructor() {
        this.events = ref({});
    }

    on(event, callback) {
        if (!this.events.value[event]) {
            this.events.value[event] = [];
        }
        this.events.value[event].push(callback);
    }

    off(event, callback) {
        if (!this.events.value[event]) {
            return;
        }
        
        if (!callback) {
            delete this.events.value[event];
            return;
        }
        
        this.events.value[event] = this.events.value[event].filter(
            cb => cb !== callback
        );
    }

    emit(event, ...args) {
        if (!this.events.value[event]) {
            return;
        }
        
        this.events.value[event].forEach(callback => {
            callback(...args);
        });
    }
}

export default new EventBus();
